<div class="categories">
    <ul class="categories__list">
        <li class="categories__list-item" *ngFor="let category of pageCategories; trackBy: trackByFn" [ngClass]="'categories__list-item--' + category.id">{{category.name}}</li>
    </ul>
</div>
